'use es6';

import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { Select } from 'foundations-components/transitional/components/Select';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { SORT_FIELD_ORDER } from '../../constants/search';
import * as FilterKey from '../../constants/search/FilterKey';
import * as SortField from '../../constants/search/SortField';
import { DEFAULT_SORT } from '../../constants/StorefrontFilters';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { updateStorefrontFilters } from '../../slices/storefrontFiltersSlice';
import { getHasFilters } from '../../utils/filters';
import { getTranslatedSortText } from '../../utils/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const textPath = 'ecosystem-marketplace-solutions-ui.storefront.results.sort';
const ValueComponent = ({
  children
}) => /*#__PURE__*/_jsx("span", {
  role: "button",
  children: children
});
const SortDropdown = ({
  filters
}) => {
  const dispatch = useDispatch();
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const hasManuallySelectedSort = useRef(false);
  const previousHasFilters = useRef(getHasFilters(filters));
  const hasFilters = useMemo(() => getHasFilters(filters), [filters]);
  const sortOptions = useMemo(() => {
    return SORT_FIELD_ORDER.filter(sort => sort !== SortField.RELEVANCE_DESC || hasFilters).map(sort => {
      return {
        text: getTranslatedSortText(sort),
        value: sort
      };
    });
  }, [hasFilters]);
  useEffect(() => {
    const currentSort = filters[FilterKey.SORTS];
    if (hasFilters && !previousHasFilters.current && !hasManuallySelectedSort.current) {
      dispatch(updateStorefrontFilters({
        updates: {
          [FilterKey.SORTS]: SortField.RELEVANCE_DESC
        }
      }));
    } else if (!hasFilters && previousHasFilters.current && currentSort === SortField.RELEVANCE_DESC) {
      hasManuallySelectedSort.current = false;
      dispatch(updateStorefrontFilters({
        updates: {
          [FilterKey.SORTS]: DEFAULT_SORT
        }
      }));
    }
    previousHasFilters.current = hasFilters;
  }, [filters, hasFilters, dispatch]);
  const handleSortChange = useCallback(evt => {
    const sort = evt.target.value;
    hasManuallySelectedSort.current = true;
    dispatch(updateStorefrontFilters({
      updates: {
        [FilterKey.SORTS]: sort
      }
    }));
    trackInteraction('change sort', {
      sortField: sort
    });
  }, [dispatch, trackInteraction]);
  return /*#__PURE__*/_jsx(InlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${textPath}.label`
    }),
    marginInlineEnd: "0",
    children: /*#__PURE__*/_jsx(Select, {
      "data-test-id": "storefront-sort-dropdown",
      buttonUse: "transparent",
      menuWidth: "auto",
      onChange: handleSortChange,
      options: sortOptions,
      placement: "bottom left",
      value: filters[FilterKey.SORTS],
      valueComponent: ValueComponent
    })
  });
};
export default SortDropdown;